import React, { Component } from 'react';
import { telechargerFichier } from '../../App_Code/API';
import { toDate, toEuros } from '../../App_Code/Utils';
import { verificationLocationState } from '../CaptureErreurs';
import SelecteurDate from '../SelecteurDate';
import Tableau from '../Tableau';

const TABLEAU_LENGENDE = [
    {}, // 0
    { titre: 'Exercice courant', classe: '' }, // 1
    { titre: 'Hors exercice courant', classe: 'table-primary' }, // 2
    {}, // 3
    { titre: 'A venir', classe: 'table-jaune' }, // 4
];

const Legende = () => (
    <span>
        <span className="col-form-label">Légende :</span>
        {TABLEAU_LENGENDE.slice(1, 3).concat(TABLEAU_LENGENDE.slice(4)).map((ligne, i) => (
            <span className={`p-2 border ml-1 ${ligne.classe}`} key={i}>
                {ligne.titre}
            </span>
        ))}
    </span>
);

const AlertePasDeLigne = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Aucune ligne d&apos;historique.</h1>
    </div>
);

const LigneHistorique = ({
    DateEcr,
    Compte,
    Libelle,
    Lot,
    TypeRegl,
    Bnq,
    Cheque,
    Debit,
    Credit,
    Solde,
    Tva,
    Rappro,
    Bord,
    Etat,
    Fichier,
}) => (
    <tr className={TABLEAU_LENGENDE[Etat].classe}>
        <th>{toDate(DateEcr, 'L')}</th>
        <td>{Compte}</td>
        <td>{Libelle}</td>
        <td>{Lot}</td>
        <td>{TypeRegl}</td>
        <td>{Bnq}</td>
        <td>{Cheque !== '0' && Cheque}</td>
        <td className="text-right">{toEuros(Debit)}</td>
        <td className="text-right">{toEuros(Credit)}</td>
        <td className={`text-right ${Solde < 0 ? 'text-danger' : ''}`}>{toEuros(Solde, true)}</td>
        <td className="text-right">{toEuros(Tva)}</td>
        <td>{Rappro}</td>
        <td className="text-right">{Bord !== 0.0 && Bord}</td>
        <td className="text-right">
            {Fichier && (
                <a target="_blank" href={telechargerFichier(Fichier)}>
                    <i className="fa fas fa-download mr-3" title="Télécharger le document" />
                </a>
            )}
        </td>
    </tr>
);

const AfficherTableau = ({ historique }) => {
    const Entete = (
        <tr>
            <th scope="col">Date</th>
            <th scope="col">Compte</th>
            <th scope="col">Libellé</th>
            <th scope="col">Lot</th>
            <th scope="col">Rg</th>
            <th scope="col">Banque</th>
            <th scope="col">Chèque</th>
            <th scope="col" className="text-right">
                Débit
            </th>
            <th scope="col" className="text-right">
                Crédit
            </th>
            <th scope="col" className="text-right">
                Solde
            </th>
            <th scope="col" className="text-right">
                Tva
            </th>
            <th scope="col">Rap</th>
            <th scope="col" className="text-right">
                Bord
            </th>
            <th scope="col" className="text-right">
                Doc
            </th>
        </tr>
    );

    const Lignes = historique.map((histo, i) => <LigneHistorique key={i} {...histo} />);

    return (
        <div className="table-responsive">
            <Tableau Entete={Entete} Lignes={Lignes} />
        </div>
    );
};

class PageBanqueHisto extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateDebut: new Date(props.location.state.DateDebExeCourant),
        };
    }

    ChangementDate = (dateDebut) => {
        if (dateDebut) {
            this.setState({ dateDebut });
        }
    };

    render() {
        const { dateDebut } = this.state;
        const { Banque } = this.props.location.state;

        const tDateDebut = new Date(dateDebut).getTime();
        const fHistorique = Banque.LsHistorique
            ? Banque.LsHistorique.filter(ligne => new Date(ligne.DateEcr).getTime() >= tDateDebut)
            : [];

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between mb-2">
                    <SelecteurDate label="À partir du : " valeurDate={dateDebut} onDayChange={this.ChangementDate} />
                    <Legende />
                </div>
                {fHistorique.length === 0 ? <AlertePasDeLigne /> : <AfficherTableau historique={fHistorique} />}
            </React.Fragment>
        );
    }
}
PageBanqueHisto.displayName = 'PageBanqueHisto';
PageBanqueHisto.requiredLocationState = [
    'Banque', // Banque interrogée
    'DateDebExeCourant', // Date de début de l'exercice courant
];

export default verificationLocationState(PageBanqueHisto);



// WEBPACK FOOTER //
// ./src/components/MaCopro/PageBanqueHisto.js